import 'isotope-layout/dist/isotope.pkgd.min.js';

export default {
    init() {
        // JavaScript to be fired on the members listing pages
        if ($('#isotope-orgs').length > 0) {
            var $grid = $('#isotope-orgs').isotope({
                itemSelector: '.org',
            });

            var iso = $grid.data('isotope');
            $grid.isotope('on', 'layoutComplete', function() {
                if (iso.filteredItems.length === 0) {
                    $('.no-results').show();
                } else {
                    $('.no-results').hide();
                }
            });

            // bind filter on select change
            $('#isotope-select').on( 'change', function() {
                // get filter value from option value
                var filterValue = this.value;
                $grid.isotope({ filter: filterValue });
                $('#isotope-orgs').removeClass('isotope--no-results');
            });
        }
    }, 
    finalize() {
        // JavaScript to be fired on the members listing pages, after the init JS
    },
};



// WEBPACK FOOTER //
// /Users/mishatrombley/Documents/Sites/aurora-institute/app/public/wp-content/themes/aurora-institute/resources/assets/scripts/routes/members.js